export default [
    {
        path: '/teacher/teacher_list',
        component: (resolve) => require(['@/components/teacher/TeacherList'],resolve),
        meta:{
            title:'教师列表',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/teacherlist.js